<template>
	<div class="notification-bar" v-if="show">
		<div>Du har en eller flere ulæste nyheder.<a class="link" @click="goToNews">Gå til nyheder</a></div>
		<span class="close" @click="close" v-html="require('@/assets/icons/cross.svg')"></span></div>
</template>

<script>
export default {
	data() {
		return {
			closed: sessionStorage.getItem("notification-tab-closed") || false
		}
	},
	computed: {
		show() {
			return this.closed ? false : this.items.some((x) => !x.visited);
		},
		items() {
			return this.$store.getters["news/allNews"];
		}
	},
	methods: {
		close() {
			this.closed = true;
			sessionStorage.setItem("notification-tab-closed", true);
		},
		goToNews() {
			const headerHeight = window.innerWidth < 768 ? 64 : 62;
			const notificationHeight = document.querySelector(".notification-bar").offsetHeight;
			const offset = headerHeight+notificationHeight;
			window.scrollTo(0, document.querySelector(".news").offsetTop-offset);
		}
	}
}
</script>

<style lang="scss" scoped>
.notification-bar {
	display: flex;
	justify-content: center;
	align-items: center;
	background-color: $blue1;
	color: white;
	position: fixed;
	width: 100%;
	top: 62px;
	min-height: 40px;
	left: 0;
	font-size: 14px;
	line-height: normal;
	@include res(mobile) {
		top: 64px;
		justify-content: space-between;
		padding: 0.8em 1.6875em;
	}
	.link {
		color: white;
		margin-left: 5px;
		text-decoration: underline;
		font-weight: 500;
	}
	.close {
		cursor: pointer;
		position: absolute;
		right: 28px;
		display: inline-flex;
		@include res(mobile) {
			position: relative;
			right: auto;
			margin-left: 20px;
		}
		/deep/ svg {
			g {
				fill: white;
			}
		}
	}
}
</style>


